import React, {FC} from 'react';
import SwitchCustom from "@ui/switchCustom/SwitchCustom";
import {useTranslation} from "react-i18next";


interface IProps{
    stickyHeader?: boolean,
    setStickyHeader: (sticky: boolean) => void,
    disabled?:boolean
}
const StickyToggleBtn:FC<IProps> = ({stickyHeader,setStickyHeader,disabled}) => {

    const{t} = useTranslation()

    return (
        <SwitchCustom
            disabled={disabled }
            label={t('base.stickyHeader')}
            onChange={setStickyHeader}
            checked={stickyHeader}
        />
    );
};

export default StickyToggleBtn;